import theme from 'library/theme/theme';
import styled from 'styled-components';

export const Main = styled.div`
  margin: 210px 70px 0 70px;
`;

export const ClientsSwitchWrapper = styled.div`
  margin-bottom: ${theme.spacing(3)};
`;

export const Content = styled.div`
  max-width: 1100px;
  margin-inline: auto;
  margin-top: ${theme.spacing(3)};
  position: relative;
`;
